import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import UserAvatar from 'react-user-avatar';
import * as apiConfig from "../../api/config";
import $ from 'jquery';

const Reaction = ({ user, userReactions, onReact, onUnReact, onChangeReaction, overrideDialog }) => {

    const [userLiked, setUserLiked] = useState(false);

    useEffect(() => {
        setUserLiked(false);
        if (user.id) {
            userReactions.users.map(u => {
                if (u.userId.toUpperCase() === user.id.toUpperCase()) {
                    setUserLiked(true);
                }
            })
        }
    }, [userReactions])

    function onToggleLike(e) {
        e.preventDefault();
        if (!userLiked) {
            onReact("Like")
            setUserLiked(true);
        }
        else {
            onUnReact(); 
            setUserLiked(false);
        }
    }

    function openModal(e) {
        e.preventDefault();
        if (userReactions.users.length > 0) {
            $(`#reactions-${userReactions.itemType}-${userReactions.itemId}`).modal("show");
        }
    }

    return (
        <div className="reaction-container">
            <span onClick={onToggleLike} className={userLiked ? "fas fa-thumbs-up route-like liked" : "far fa-thumbs-up route-like"}></span>
            <span onClick={openModal} className="item-counter">({userReactions.users.length})</span>
            {!overrideDialog &&
                <div className="modal fade" id={`reactions-${userReactions.itemType}-${userReactions.itemId}`} tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                <h5 className="modal-title" >Reactions</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body reactions-modal-body">
                                <div className="row justify-content-center">
                                    <div className="col-11">
                                        <ul className="mt-4 all-reactions">
                                            {
                                                userReactions.users.map(user => {
                                                    return (
                                                        <li key={user.userId} className="reactor" title={`${user.firstName} ${user.surname}`} >
                                                            <UserAvatar className="reactor-avatar" size="40" name={`${user.firstName} ${user.surname}`} src={user.hasAvatar ? `${apiConfig.API_URL}user/avatar/${user.userId}.png` : ""} />
                                                            <div className={"reaction"}><span className={"fas fa-thumbs-up"}></span></div>
                                                            <div className="reactor-name">{`${user.firstName} ${user.surname}`}</div>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

Reaction.propTypes = {
    userReactions: PropTypes.object.isRequired,
    onReact: PropTypes.func.isRequired,
    onUnReact: PropTypes.func.isRequired,
    onChangeReaction: PropTypes.func,
    overrideDialog: PropTypes.bool
}

export default Reaction; 


// WEBPACK FOOTER //
// ./src/components/common/Reaction.js